const { dawaAutocomplete } = require("dawa-autocomplete2");
$(async function () {
    if ($("#dawa_search").length > 0) {
        let works = true;
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 10000);
        try {
            const testRequest = await fetch('https://api.dataforsyningen.dk/autocomplete?q=test', {
                signal: controller.signal
            });
            clearTimeout(timeoutId);
            if (!testRequest.ok) {
                console.error("DAWA service returned an error status:", testRequest.status);
                works = false;
            }
        } catch (error) {
            if (error.name === 'AbortError') {
                console.error("DAWA service check timed out");
            } else {
                console.error("Error while checking DAWA service:", error);
            }
            works = false;
        }
        if (!works) {
            console.warn("DAWA service is not reachable. Autocomplete will not be initialized.");
            $("#dawa_search").attr("readonly", true);
            $("#dawa_error_message").removeClass('d-none');
            $("#order_delivery_address_attributes_zipcode").removeAttr("readonly");
            $("#order_delivery_address_attributes_city").removeAttr("readonly");
            $("#order_delivery_address_attributes_latitude").removeAttr("readonly");
            $("#order_delivery_address_attributes_longitude").removeAttr("readonly");
            $("#order_delivery_address_attributes_access_latitude").removeAttr("readonly");
            $("#order_delivery_address_attributes_access_longitude").removeAttr("readonly");
            $("#order_delivery_address_attributes_address_1").removeAttr("readonly");
            return;
        }
        dawaAutocomplete(document.getElementById("dawa_search"), {
            select: function (selected) {
                $("#order_delivery_address_attributes_zipcode").val(selected.data.postnr);
                $("#order_delivery_address_attributes_city").val(selected.data.postnrnavn);
                $.getJSON(selected.data.href, data => {
                    $("#order_delivery_address_attributes_latitude").val(data.adgangsadresse.adgangspunkt.koordinater[1]);
                    $("#order_delivery_address_attributes_longitude").val(data.adgangsadresse.adgangspunkt.koordinater[0]);
                    $("#order_delivery_address_attributes_access_latitude").val(data.adgangsadresse.vejpunkt.koordinater[1]);
                    $("#order_delivery_address_attributes_access_longitude").val(data.adgangsadresse.vejpunkt.koordinater[0]);
                });

                var parts = selected.forslagstekst.split("\n");
                parts.pop();
                var streetname = parts.join(",");

                $("#order_delivery_address_attributes_address_1").val(streetname);
            }
        });
    }
});
